import React, { Component } from 'react'
import Button from 'components/button/button'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Icon from 'components/icon/icon'

import {
	logoutUser
} from 'state/actions'

class ModalError extends Component {
	doAction(){
		const {
			data,
			closeCallback,
			logoutUser
		} = this.props

		if(data && data.shouldLogOut){
			logoutUser()
		}

		closeCallback()
	}

	render() {
		const {
			data
		} = this.props

		return(
			<div>
				<div className={'modal-task with-decoration'}>
					<img className="decoration" src={document.base+"/images/decoration/error.png"} />
					<h3>
						{ data.message }
					</h3>
				</div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={_ => {this.doAction()}} 
					label={data && data.shouldLogOut ? 'Try logging out' : 'Okay'} 
					icon={'check'} 
				/>
			</div>
		);
	}
}

export default withRouter(connect(null,{
	logoutUser
})(ModalError));
